import { FC } from 'react';
import FooterPrivacyPolicy from '../footer/footer-privacy-policy';
import { VIEW_RESOLVER } from '@/data/constants';

// @ts-ignore: federated module
import ViewResolverSection from 'ldpViewResolverSdm/Section';

const ModernizedFooter: FC = () => {
  const { API_VERSION_V2: apiVersion, MAIN_CONTENT_COLLECTION } = VIEW_RESOLVER;

  return (
    <>
      <ViewResolverSection apiVersion={apiVersion} layoutSection={MAIN_CONTENT_COLLECTION} hasFooter />
      <FooterPrivacyPolicy />
    </>
  );
};

export default ModernizedFooter;
